import { ref } from "vue";

import type { Ref } from "vue";

interface DropDownMenuData {
  showMenu: Ref<boolean>;
  toggleMenu: () => void;
  closeMenu: ({ afterClose }: { afterClose: () => void }) => void;
  menuActivator: Ref<HTMLElement | null>;
}

export const useDropdownMenu = (): DropDownMenuData => {
  const showMenu = ref<boolean>(false);
  const menuActivator = ref<HTMLElement | null>(null);

  const toggleMenu = () => {
    if (!showMenu.value) {
      document.body.click();
    }
    showMenu.value = !showMenu.value;
  };

  const closeMenu = ({ afterClose }: { afterClose: () => void }): void => {
    showMenu.value = false;
    afterClose?.();
  };

  return {
    showMenu,
    menuActivator,
    toggleMenu,
    closeMenu,
  };
};
